__turbopack_context__.v({
  "active": "vNBD4W_active",
  "sidebarListItem": "vNBD4W_sidebarListItem",
});
